import instanceRequest, {Request} from "../../main/services/Request";
import {
    PAGINATION_HEADERS,
    STATUS_INDEX_DEFECT,
    STATUS_INDEX_NORMAL,
    STATUS_INDEX_UNAVAILABLE,
    STATUS_LIST,
} from "../../main/store/constants";

class EquipmentService {
    private axiosService: Request;

    public constructor(axiosService: Request) {
        this.axiosService = axiosService;
    }

    public async getEquipments(
        page = 1,
        filters = {status: null, locationReferences: [], equipment: [], query : ""},
        functionalType:string|null = "arrosage",
        sortField = "status_state_changed_at",
        sortDirection = "desc",
        itemsPerPage = 20,

    ) {
        let filtersStatusQuery = "";
        if (filters.status) {
            filtersStatusQuery = this.formatStatusFilters(filters.status);
        }
        const body = {locationReference: filters.locationReferences ? filters.locationReferences.map((item: any) => item.id) : [], equipment: filters.equipment || []};

        // all filters are deactivated
        if (filtersStatusQuery === "" && filters.status) {
            return await new Promise((resolve, reject) => {
                resolve({
                    pagination: [],
                    data: [],
                });
            });
        }
        const functionalTypeParam = functionalType ? `&functionalType=${functionalType}`: ''
        const url = `/api/equipment/list?currentPage=${page}&itemsPerPage=${itemsPerPage}&sortKey=${sortField}&sortDir=${sortDirection}&${filtersStatusQuery}${functionalTypeParam}&query=${filters.query}`;
        
        const response = await this.axiosService.post(url, body, false);
        return {
            pagination: this.getPaginationInfo(response.headers),
            data: response.data,
        };
    }

    public getEquipment(id: string) {
        const url = `/api/equipment/${id}`;
        return this.axiosService.get(url, false, false).then((response) => {
            return {
                data: response.data,
            };
        });
    }

    public getEquipmentStats(filters = {status: null, locationReferences: []}, functionalType = "arrosage") {
        let filtersStatusQuery = "";
        if (filters.status) {
            filtersStatusQuery = this.formatStatusFilters(filters.status);
        }
        const body = {locationReference: filters.locationReferences ? filters.locationReferences.map((item: any) => item.id) : []};

        // all filters are deactivated
        if (filtersStatusQuery === "" && filters.status) {
            return new Promise((resolve, reject) => {
                resolve({
                    [STATUS_LIST[STATUS_INDEX_DEFECT]]: 0,
                    [STATUS_LIST[STATUS_INDEX_UNAVAILABLE]]: 0,
                    [STATUS_LIST[STATUS_INDEX_NORMAL]]: 0,
                });
            });
        }
        const url = `/api/equipment/count/status?${filtersStatusQuery}&functionalType=${functionalType}`;
        return this.axiosService.post(url, body, false).then((response) => {
            return response.data;
        });
    }

    public getPaginationInfo(headers: any): any {
        const pagination: any = [];

        Object.entries(headers).map((header: any) => {
            if (PAGINATION_HEADERS.includes(header[0])) {
                pagination[header[0]] = header[1];
            }
            return pagination;
        });

        return pagination;
    }

    private formatStatusFilters(filters: any) {
        let filterQuery = "";
        for (const [key, value] of Object.entries(filters)) {
            if (value === true) {
                filterQuery = filterQuery ? `${filterQuery}&filterStatus[]=${key}` : `filterStatus[]=${key}`;
            }
        }

        return filterQuery;
    }
}

export default new EquipmentService(instanceRequest);
